import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import "moment/locale/th";
import * as userApi from "../../../service/userApi";
import { splitBirthday } from "../../../utils/utils";
import { CurrentUserContext } from "../../../App";

function LoginHealthID() {
  const { setUserRole, setIsMessage } = useContext(CurrentUserContext);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    getParameter();
  }, []);

  const getParameter = () => {
    let url = decodeURIComponent(window.location.href);
    let newUrl = new URL(url);
    let data = newUrl.searchParams;

    if (data.get("code")) {
      loginHealthID(data.get("code"));
    } else {
      setIsMessage({ type: "warning", data: "code is require." });
      nav("/login");
    }
  };

  const loginHealthID = async (code) => {
    setLoading(true);
    let res = await userApi.loginHealthID(code);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "login success" });
        logedIn(res["data"]);
      } else if (res["data"]["code"] === 404) {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || "ไม่พบข้อมูลผู้ใช้งาน กรุณาสมัครใช้งานก่อน",
        });
        // backend sends the profile under mohpromt_user_data for every provider
        let data = res["data"]["mohpromt_user_data"] || {};
        nav("/register", {
          state: {
            type: "register_health_id",
            pname: data["pname"],
            fname: data["fname"],
            lname: data["lname"],
            pid: data["pid"],
            phoneNumber: data["phone_number"],
            healthId: data["account_id"],
            registerToken: data["register_token"],
            role: data["role"] || "PATIENT",
            ...splitBirthday(data["birthday"]),
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        nav("/login");
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      nav("/login");
    }
  };

  const logedIn = (data) => {
    localStorage.setItem("pg_access_token", data["user_data"]["auth"]["access_token"]);
    localStorage.setItem("expire_login_user", data["user_data"]["auth"]["access_token_expire"]);
    localStorage.setItem("user", JSON.stringify(data["user_data"]));

    setUserRole(data["user_data"]);
    nav("/patient/laboratoryresult");
  };

  return (
    <div className="global-page h-[80vh]">
      <HashLoader
        loading={loading}
        style={{ display: "flex", justifyContent: "center" }}
        color="#FF9768"
      />
    </div>
  );
}

export default LoginHealthID;
